const get = require('lodash.get');

export const getData = obj => {
  return get(obj, 'data.data', null);
};
